(function(root, $) {
    var $window = $(window);

    var Mobileweb = root.Mobileweb = (root.Mobileweb || {});
    Mobileweb.ads = {
        banner: "",
        square: "",
        promotion: ""
    };
    Mobileweb.params = {};
    var publish = MW.events.publish;
    Mobileweb.throttle = function(fn, wait) {
        var lastCall = 0,
            timeout = null,
            args = null,
            context = null;
        var later = function() {
            fn.apply(context, args);
            timeout = args = context = null;
            lastCall = Date.now();
            return lastCall;
        };
        return function() {
            var remaining = wait - (Date.now() - lastCall);
            if (remaining <= 0 && !timeout) {
                args = arguments;
                context = this;
                later();
            } else if (!timeout) {
                args = arguments;
                context = this;
                timeout = setTimeout(later, wait);
            } else {
                args = arguments;
                context = this;
            }
            return null;
        };
    };
    // Stops a function from being invoked repeatedly
    // waits x ms before making the call
    // referenced from underscore
    Mobileweb.debounce = function(func, wait) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                timeout = null;
                func.apply(context, args);
            }, wait);
        };
    };

    Mobileweb.loadDeferredIframes = function() {
        $('.deferred_iframe').each(function() {
            $(this).replaceWith(this.innerHTML);
        });
    };

    Mobileweb.init = function() {
        $(document).ready($.proxy(this.initOnDomReady, this));
        $window.load($.proxy(this.initOnPageLoad, this));
    };

    Mobileweb.initOnDomReady = function() {
        publish('init_dom_ready');
    };

    Mobileweb.initOnPageLoad = function() {
        publish('page_loaded');
        this.resizeFBEmbed();
        Mobileweb.loadDeferredIframes();
        // if iphone or ipad, attempt to hide addressbar
        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
            setTimeout(function() {
                // only scroll if we're still at top of page
                if ($window.scrollTop() === 0) {
                    window.scrollTo(0, 1);
                }
            }, 250);
        }
    };

    // Run this in a set timeout to get some consistency,
    // because we have this call wrapped in other set timeouts
    // This will set the beacon AFTER a click event/beacon firing
    Mobileweb.toggleBeacon = function(id, beacon_obj) {
        setTimeout(function() {
            var key;
            var toggle = $(id);
            var beacon = JSON.parse(toggle.attr("data-beacon") || '{"p":{}}');
            for (key in beacon_obj) {
                if (beacon_obj.hasOwnProperty(key)) {
                    beacon["p"][key] = beacon_obj[key];
                }
            }
            toggle.attr("data-beacon", JSON.stringify(beacon));
        }, 0);
    };

    Mobileweb.getQueryStringParameter = function(uri, key) {
        var re = new RegExp("([?|&])" + key + "=(.*?)(&|$)", "i");
        var separator = (uri.indexOf("?") !== -1 ? "&" : "?");
        var match = uri.match(re) || ["", "", ""];
        return match[2];
    };

    Mobileweb.resizeFBEmbed = function() {
        var postWidth;
        var $fbPost = $('.fb-post');
        var parseNewWidth = function() {
            postWidth = $window.width();
            if (postWidth < 350) {
                postWidth = 350;
            }
            if (postWidth > 750) {
                postWidth = 750;
            }
            $fbPost.attr('data-width', postWidth);
            return FB.XFBML.parse();
        };
        if ($fbPost.length > 0) {
            $window.on('resize', Mobileweb.debounce(parseNewWidth, 50));
        }
    };
})(this, jQuery);